<template>
  <div
    id="faq"
    class="faq"
  >
    <div class="accordion">
      <div
        v-for="item in items"
        :key="item.id"
        class="acc_item"
        :class="{ open: isOpen(item) }"
      >
        <h3
          class="acc_title"
          @click="toggleOpen(item)"
        >
          <span class="acc_chevron">
            <svg
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
              />
            </svg>
          </span>
          {{ item.title }}
        </h3>
        <div
          v-if="item.textWithLink"
          v-show="isOpen(item)"
          class="acc_text"
        >
          <p>
            <span
              v-for="(textLink, ii) in item.textWithLink"
              :key="ii + 'plt'"
              class="position-relative"
            >
              <component
                :is="textLink.linkKey === 'ROADMAP' ? 'span' : 'a'"
                v-if="textLink.navLink"
                class="link-in-text"
                :href="links[textLink.linkKey]"
                target="_blank"
                @click.stop
                @click="openRoadmapDialog(textLink.linkKey)"
                >{{ textLink.navLink }}</component
              >
              <img
                v-else-if="textLink.imgSrc"
                class="smile-face"
                :src="getImage(textLink.imgSrc)"
              />
              <!-- <ul>
                <li>saxasx</li>
              </ul> -->
              <span
                v-else
                v-html="textLink"
              ></span>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'

export default {
  name: 'Faq',
  mixins: [links_mix],
  data() {
    return {
      openSections: [],
      links: {
        ROADMAP: '#',
        MYPROFILE: '/user/subscription',
        DISCORD: 'https://discord.com/invite/ht3QxrP',
        ARTICLE: 'https://blog.gtowizard.com/what-the-future-holds-for-gto-wizard/',
      },
    }
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/img/${img}`, import.meta.url).href
    },
    openRoadmapDialog(linkKey) {
      if (linkKey === 'ROADMAP') {
        this.$store.dispatch('router_set_dialogs', 'roadmap-dialog')
      }
    },
    isOpen(item) {
      return this.openSections.some(i => i.id === item.id)
    },
    toggleOpen(item) {
      if (this.isOpen(item)) {
        this.openSections = this.openSections.filter(i => i.id !== item.id)
        return
      }
      this.openSections = [...this.openSections, item]
    },
  },
  computed: {
    items() {
      if (this.$route.name === 'SubscriptionOverview') {
        return [
          {
            title: this.$t('faqs.tier_overview.item_0.title'),
            textWithLink: [
              this.$t('faqs.tier_overview.item_0.text_0'),
              {
                navLink: ' Discord',
                linkKey: 'DISCORD',
              },
              '.',
            ],
          },
          {
            title: this.$t('faqs.tier_overview.item_1.title'),
            textWithLink: [
              this.$t('faqs.tier_overview.item_1.text_0_tra01'),
              // {
              //   navLink: ` ${this.$t('faqs.tier_overview.item_1.text_1')} `,
              //   linkKey: 'ARTICLE',
              // },
              // this.$t('faqs.tier_overview.item_1.text_2'),
              {
                navLink: ` ${this.$t('faqs.tier_overview.item_1.text_3_tra01')}`,
                linkKey: 'ROADMAP',
              },
              '.',
            ],
          },
          {
            title: this.$t('faqs.tier_overview.item_2.title'),
            textWithLink: [
              this.$t('faqs.tier_overview.item_2.text_0_tra01', {
                team_member: '@GTOWizard Jerry',
              }),
              {
                navLink: ' Discord',
                linkKey: 'DISCORD',
              },
              '.',
            ],
          },
          {
            title: this.$t('faqs.tier_overview.item_3.title'),
            textWithLink: [this.$t('faqs.tier_overview.item_3.text_0')],
          },

          {
            title: this.$t('faqs.tier_overview.item_5_updated.title'),
            textWithLink: [
              this.$t('faqs.tier_overview.item_5_updated.text_0'),
              {
                navLink: ` ${this.$t('faqs.tier_overview.item_5_updated.text_1')}`,
                linkKey: 'MYPROFILE',
              },
              '.',
              this.$t('faqs.tier_overview.item_5_updated.text_2'),
            ],
          },
          {
            title: this.$t('faqs.tier_overview.item_6.title'),
            textWithLink: [
              this.$t('faqs.tier_overview.item_6.text_0'),
              {
                navLink: ` ${this.$t('faqs.contact_us_discord')}`,
                linkKey: 'DISCORD',
              },
              '.',
            ],
          },
          {
            title: this.$t('faqs.tier_overview.item_7.title'),
            textWithLink: [
              this.$t('faqs.tier_overview.item_7.text_0'),
              {
                navLink: ` ${this.$t('faqs.tier_overview.item_7.text_1')} `,
                linkKey: 'DISCORD',
              },
              this.$t('faqs.tier_overview.item_7.text_2'),
              {
                navLink: ` ${this.$t('faqs.tier_overview.item_7.text_3')} `,
                linkKey: 'DISCORD',
              },
              this.$t('faqs.tier_overview.item_7.text_4'),
              {
                imgSrc: 'winking_face.webp',
              },
              // '.',
            ],
          },
        ].map((i, idx) => ({ ...i, id: idx }))
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1024px) {
  .accordion {
    .acc_text {
      font-size: 1.1rem !important;
    }
  }
}
.smile-face {
  position: absolute;
  height: 1.8rem;
  right: -2.2rem;
}
.link,
.link-in-text {
  color: var(--clr-primary);
  text-decoration: none;
  cursor: pointer;
  &:hover {
    border-bottom: var(--clr-primary) solid 2px;
  }
}
.link {
  padding: 1rem 0 0 0;
}
.faq {
  padding: 0 0 4rem 0;
  align-items: center;
  position: relative;
  z-index: 2;
  flex-direction: column;
}
h1 {
  text-align: center;
}
.accordion {
  max-width: var(--max-text-width);
  margin: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  .open {
    .acc_text {
      padding-bottom: 1.5rem;
    }
    .acc_chevron {
      transform: scale(1.5) rotate(90deg);
    }
  }
  .acc {
    &_item {
      position: relative;

      &:after {
        content: '';
        width: 100%;
        height: 2px;
        background: var(--clr-white-0);
        position: absolute;
      }
    }
    &_title {
      cursor: pointer;
      margin: 0;
      display: flex;
      align-items: center;
      font-weight: 500;
      padding: 2rem 0 2rem 0;
      color: var(--clr-white-0);
    }
    &_chevron {
      height: 24px;
      margin: 0 1.5rem 0 0;
      transition: 0.2s;
      transform: scale(1.5);
    }
    &_text {
      margin: 0;
      padding: 0 0 0 3rem;
      display: flex;
      font-weight: 300;
      align-items: center;
      font-size: 1.25rem;
      color: var(--clr-white-0);
    }
  }
}
</style>
